import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';

@Pipe({
  name: 'onlyTime'
})
export class OnlyTimePipe implements PipeTransform {

  constructor(private translate: TranslateService){}

  transform(endDate: moment.Moment, startDate: moment.Moment, onlyTime: boolean = true): string {
    if (!endDate || !endDate.isValid() || !startDate || !startDate.isValid()) {
      return this.translate.instant('pipe.fulldate.error');
    }

    if(endDate.format('YYYY-MM-DD') === startDate.format('YYYY-MM-DD') && onlyTime){
      return endDate.format('HH:mm')
    }

    return endDate.format('YYYY-MM-DD HH:mm');
  }

}
